import React, { useEffect, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import "../../css/coupon/ManageCoupon.css";
import "../../css/Manage.css";
import moment from "moment";
import CouponApi from "../../api/couponApi";
import AlertPopup from "../../components/AlertPopup";
import { toast } from "react-toastify";

const ManageCoupon = () => {
  let navigate = useNavigate();
  const { page } = useParams();
  const location = useLocation();

  const [searchParams, setSearchParams] = useSearchParams();

  const [communityList, setCommunityList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [startIndex, setStartIndex] = useState(0);
  const [pageIndex, setPageIndex] = useState([]);
  const [postsPerPage, setPostsPerPage] = useState(null);
  const [alertValue, setAlertValue] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setSearchKeyword(
      searchParams.get("keyword") ? searchParams.get("keyword") : ""
    );
    setCurrentPage(Number(page));
    getCommunityList();
  }, [currentPage, location]);

  const getCommunityList = async () => {
    try {
      const communityInfo = (
        await CouponApi.Get({
          page: currentPage,
          size: 10,
          keyword: searchParams.get("keyword"),
        })
      ).data.data;
      setCommunityList(communityInfo.content);
      setTotalCount(communityInfo.totalCount);
      setPostsPerPage(communityInfo.content.length);
      const count = Math.ceil(
        communityInfo.totalCount / communityInfo.content.length / 4
      );

      for (let i = 1; i <= count; i++) {
        if (currentPage / 4 <= i) {
          setStartIndex(4 * (i - 1));
          return;
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    let page = Math.ceil(totalCount / postsPerPage);
    let arr = [];
    for (var i = 1; i <= page; i++) {
      arr.push(i);
    }
    setPageIndex(arr);
  }, [totalCount]);

  const handleDelete = async (id) => {
    setIsOpen(true);
    setDeleteId(id);
  };

  const [deleteId, setDeleteId] = useState(-1);
  useEffect(() => {
    const del = async () => {
      try {
        if (deleteId <= 0) {
          return;
        }
        await CouponApi.Del(deleteId).then(() => {
          toast("삭제되었습니다.");
          setTimeout(() => {
            window.location.reload();
          }, 500);
        });
      } catch (error) {
        toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
      }
    };
    if (alertValue) {
      del();
    }
  }, [alertValue]);

  return (
    <div className="Manage-container">
      <section className="Manage-contents Manage-contents-table">
        <span>쿠폰 관리</span>
        <div className="manage-table-container">
          <div className="Manage-coupon-search-container">
            <div className="Manage-coupon-search-number">
              <span>전체</span>
              <span>{totalCount}</span>
            </div>
            <div className="Manage-coupon-search">
              <div style={{ position: "relative" }}>
                <input
                  className="table-search-input"
                  type="text"
                  placeholder="검색어를 입력하세요"
                  onChange={(e) => {
                    setSearchKeyword(e.target.value);
                  }}
                  value={searchKeyword}
                />
                <img
                  src="/img/search.svg"
                  alt=""
                  style={{
                    position: "absolute",
                    right: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    navigate(`/admin/coupon/1?keyword=${searchKeyword}`);
                  }}
                />
              </div>

              <div
                className="cursorPointer"
                onClick={() => navigate("/admin/coupon/add")}
              >
                <img src="\img\see-more-btn-plus.svg" />
                <span>쿠폰 생성</span>
              </div>
            </div>
          </div>
          <div className="Manage-table manage-table-coupon">
            <table>
              <thead>
                <tr>
                  <th>이름</th>
                  <th>서브타이틀</th>
                  <th>할인</th>
                  <th>타입</th>
                  <th>공간명</th>
                  <th>만료일자</th>
                  <th>생성일자</th>
                  <th>삭제</th>
                </tr>
              </thead>
              <tbody>
                {communityList.map((item, index) => {
                  let createDate = moment(item.createdAt)
                    .local()
                    .format("YYYY/MM/DD");
                  return (
                    <tr key={index}>
                      <td>{item.name}</td>
                      <td>{item.subtitle}</td>
                      <td>{item.discountPercent}</td>
                      <td>
                        {item.type === "RESIDENCY"
                          ? "거주권"
                          : item.type === "MEETING"
                          ? "모임"
                          : "공간"}
                      </td>
                      <td>{item.spaceName}</td>
                      <td>{moment(item.dueAt).local().format("YYYY/MM/DD")}</td>
                      <td>{createDate}</td>
                      <td>
                        <div>
                          <a onClick={() => handleDelete(item.id)}>삭제</a>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="manage-table-pagenation-container">
              <div className="manage-table-pagenation">
                <a
                  onClick={() => {
                    if (currentPage <= 1) {
                      return;
                    } else {
                      navigate(
                        `/admin/coupon/${
                          currentPage - 1
                        }?keyword=${searchKeyword}`
                      );
                    }
                  }}
                >
                  <img src="\img\chevron-left.svg" />
                </a>
                {pageIndex
                  .slice(startIndex, startIndex + 4)
                  .map((item, index) => {
                    return (
                      <a
                        key={index}
                        className={
                          currentPage === item ? "pagenation-focus" : null
                        }
                        onClick={() => {
                          navigate(
                            `/admin/coupon/${item}?keyword=${searchKeyword}`
                          );
                        }}
                      >
                        {item}
                      </a>
                    );
                  })}
                <a
                  onClick={() => {
                    if (currentPage >= pageIndex.length) {
                      return;
                    } else {
                      navigate(
                        `/admin/coupon/${
                          currentPage + 1
                        }?keyword=${searchKeyword}`
                      );
                    }
                  }}
                >
                  <img src="\img\chevron-right.svg" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <AlertPopup
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          headerTitle={"삭제 하시겠습니까?"}
          content={"삭제된 데이터는 복구가 불가능합니다."}
          setAlertValue={setAlertValue}
          cancelTitle={"취소"}
          confirmTitle={"삭제"}
        />
      </section>
    </div>
  );
};

export default ManageCoupon;
